import React, { useEffect, useState } from "react";
import "./Header.scss";
import { FormControl, InputLabel, Menu, MenuItem, Select } from "@mui/material";
import BreadCrumb from "../../components/BreadCrumb/BreadCrumb";
import BusinessUnitSelection from "../../components/common/BusinessUnitSelection/BusinessUnitSelection";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Select as AntSelect, Button } from "antd";
import { useSelector } from "react-redux";
declare const changeBrowserLang: any;
const Header = (props: any) => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const { Option } = AntSelect;

  const { logoutAction, headerMenuAction } = props;
  const location = useLocation();

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [Language, setLanguage] = useState(
    localStorage.getItem("language") || "en"
  );
  const [showAppAuthSetup, setShowAppAuthSetup] = useState(false);
  const [showAppAuthReset, setShowAppAuthReset] = useState(false);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleChangeLanguage = (event: any) => {
    const lang = event.target.value;
    setLanguage(lang);
    // setLanguage("en");
    localStorage.setItem("language", lang);
    changeBrowserLang(lang);
  };
  const handleClose = (type?: string) => {
    setAnchorEl(null);
    if (type === "logout") {
      logoutAction();
      //navigate('/auth/login');
    } else if (type === "profile") {
      headerMenuAction({ type: "profile" });
    } else if (type === "resetPassword") {
      headerMenuAction({ type: "resetPassword" });
    } else if (type === "appAuthSetup") {
      headerMenuAction({ type: "appAuthSetup" });
    } else if (type === "appAuthEdit") {
      headerMenuAction({ type: "appAuthEdit" });
    }
  };
  const username =
    localStorage.getItem("user") &&
    (JSON.parse(localStorage.getItem("user") || "").displayName ||
      JSON.parse(localStorage.getItem("user") || "").email);

  const showResetPassword = !localStorage.getItem("auditRequestId");
  const showProfile = !localStorage.getItem("auditRequestId");
  const companyPreferences = useSelector(
    (state: any) => state.org.companyPreferences
  );
  const userDetails = useSelector((state: any) => state.user.userDetails);

  useEffect(() => {
    if (
      Object.keys(companyPreferences).length &&
      Object.keys(userDetails).length
    ) {
      if (companyPreferences.app_auth_enabled) {
        if (userDetails.appAuthSetup) {
          setShowAppAuthReset(true);
          setShowAppAuthSetup(false);
        } else {
          setShowAppAuthSetup(true);
          setShowAppAuthReset(false);
        }
      } else {
        setShowAppAuthSetup(false);
        setShowAppAuthReset(false);
      }
    }
  }, [companyPreferences, userDetails]);
  return (
    <div className="bg-white flex flex-row items-center">
      <div className="pw-header flex flex-row grow justify-between">
        <BreadCrumb className="pw-bread-crumbs" />
        <div className="flex flex-row gap-5">
          {localStorage.getItem("user") &&
            JSON.parse(localStorage.getItem("user") || "").role === 7 &&
            location.pathname.toLowerCase().includes("log/emissions") && (
              <div className="flex items-center">
                <Button
                  className="bg-primary text-white"
                  onClick={() => {
                    navigate("/auditsummary");
                  }}
                >
                  View audit summary
                </Button>
              </div>
            )}
          {localStorage.getItem("businessUnits") &&
            !/\basset\b/.test(location.pathname) &&
            !/\boffset\b/.test(location.pathname) &&
            !location.pathname.includes("dashboard") &&
            !location.pathname.includes("facility") &&
            !location.pathname.includes("facilityconfigurations") &&
            !location.pathname.includes("reports") &&
            !location.pathname.includes("logemissions") &&
            !location.pathname.includes("employee") &&
            !location.pathname.includes("target") &&
            !location.pathname.includes("customemissionfactor") &&
            !location.pathname.includes("customemission") &&
            !location.pathname.includes("audit") &&
            !location.pathname.includes("sourceemissionfactor") && (
              <BusinessUnitSelection />
            )}
          <FormControl fullWidth size="small">
            <Select
              value={Language}
              className="pw-language notranslate"
              placeholder="Select Language"
              onChange={handleChangeLanguage}
            >
              <MenuItem className="notranslate" value="en" key="1">
                English
              </MenuItem>
              <MenuItem className="notranslate" value="th" key="2">
                ภาษาไทย
              </MenuItem>
              <MenuItem className="notranslate" value="vi" key="3">
                tiếng việt
              </MenuItem>
              <MenuItem className="notranslate" value="zh-CN" key="4">
                简体中文
              </MenuItem>
              <MenuItem className="notranslate" value="id" key="5">
                Bahasa Indonesia
              </MenuItem>
              <MenuItem className="notranslate" value="ms" key="6">
                Bahasa Melayu
              </MenuItem>
              <MenuItem className="notranslate" value="ja" key="7">
                日本語
              </MenuItem>
              <MenuItem className="notranslate" value="ko" key="8">
                한국인
              </MenuItem>
              <MenuItem className="notranslate" value="zh-TW" key="9">
                國語
              </MenuItem>
              <MenuItem className="notranslate" value="tr" key="10">
                Türkçe
              </MenuItem>
              <MenuItem className="notranslate" value="hi" key="11">
                हिन्दी
              </MenuItem>
              <MenuItem className="notranslate" value="ar" key="12">
                عربي
              </MenuItem>
            </Select>
          </FormControl>

          <div className="pw-right-view flex flex-row items-center ">
            <div className="flex grow justify-center">
              <button
                className="flex pw-profile mr-6 pw-cursor-pointer"
                id="basic-button"
                aria-controls={open ? "basic-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
                onClick={handleClick}
              >
                {username?.charAt(0).toUpperCase()}
              </button>

              <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={() => handleClose()}
                MenuListProps={{
                  "aria-labelledby": "basic-button",
                }}
              >
                {/* {showAppAuthSetup && (
                  <MenuItem
                    onClick={() => handleClose("appAuthSetup")}
                    className="pw-menu-item"//change class names
                  >
                    <div className="flex flex-col">
                      <div
                        className="pw-setup-2FA-button !w-full"
                      >
                        Setup 2FA Configuration
                      </div>
                    </div>
                  </MenuItem>
                )} */}
                {showProfile && (
                  <MenuItem
                    onClick={() => handleClose("profile")}
                    className="pw-e2e-userprofile pw-menu-item"
                  >
                    {t("Profile")}
                  </MenuItem>
                )}
                {showAppAuthSetup && (
                  <MenuItem
                    onClick={() => handleClose("appAuthSetup")}
                    className=" pw-menu-item"
                  >
                    {t("Setup 2FA Configuration")}
                  </MenuItem>
                )}
                {showAppAuthReset && (
                  <MenuItem
                    onClick={() => handleClose("appAuthEdit")}
                    className=" pw-menu-item"
                  >
                    {t("Edit 2FA Configuration")}
                  </MenuItem>
                )}
                {showResetPassword && (
                  <MenuItem
                    onClick={() => handleClose("resetPassword")}
                    className="pw-e2e-resetpassword pw-menu-item"
                  >
                    {t("Reset Password")}
                  </MenuItem>
                )}

                <MenuItem
                  onClick={() => handleClose("logout")}
                  className="pw-e2e-logout pw-menu-item"
                >
                  {t("Logout")}
                </MenuItem>
              </Menu>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

// Header.propTypes = {}

export default Header;
